export default {
  shippingPromiseBeforeChristmas: {
    id: 'cart_shipping_free_before_christmas',
    defaultMessage: 'Free delivery before Christmas, {earliest} - {latest}',
  },
  shippingPromiseExpressBeforeChristmas: {
    id: 'cart_shipping_express_before_christmas',
    defaultMessage: 'Express delivery before Christmas, {earliest} - {latest}',
  },
  shippingPromise: {
    id: 'cart_shipping_promise',
    defaultMessage: 'Get it by {earliest} - {latest} • Free',
  },
  shippingPromiseExpress: {
    id: 'cart_express_shipping_promise',
    defaultMessage: 'Express by {earliest} - {latest} • from {amount}',
  },
}
